import React from 'react'
import Section from '../components/Section'

function ShippingAndReturns() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>Shipping &amp; Returns</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='ship-and-ret__section'>
				<div className='col-12 col-md-10 offset-md-1 offset-0'>
					<p>
						Because The Etho uses a platform model, we don’t keep or
						process any inventory, and each The Etho Shop is
						responsible for shipping items directly to customers.
						This means that while we can’t take responsibility for
						any packages or shipment – related issues that may arise
						(hopefully they never do!), we are always here to help
						figure out shipping issues with customers and sellers if
						both parties can’t resolve an issue on their own.
					</p>
					<p>
						That being said, if a shop owner does not have a
						specific policy on shipping, exchanges or returns in
						place, then The Etho’s general policies on shipping,
						etc., will automatically be used to handle any issues
						you may have. These are detailed below. Also, please
						don’t hesitate to ask us questions about these policies
						if you run into any issues – being a small, new company
						we are trying to figure out the best shipping procedures
						and the best way to keep our supply chains effective,
						affordable, and sustainable for everyone involved.
					</p>
					<ul>
						<li>
							<p>
								Sellers usually ship ordered item(s) within 48
								hours of a customer’s purchase. Unless products
								are custom made-to-order pieces, then sellers
								are required to specify a shipping time frame
								(“processing time”) for customers based on the
								location of their shipping destination. All
								sellers on The Etho are required to purchase
								shipping insurance, the cost of which is usually
								factored into the sale price of an item. (We use
								shipping insurance because it is inexpensive,
								but important for seller, and customer
								protection.)
							</p>
						</li>
						<li>
							<p>
								A shop’s homepage of The Etho should display
								policies or procedures that their customers can
								easily understand – whether or not refunds,
								returns or exchanges are accepted for instance.
								These policies usually aren’t very complicated,
								but should be detailed and clear enough that
								customers can easily understand a shop’s
								shipping costs/procedures, processing times, the
								use of shop discounts, order cancellations, etc.
							</p>
							<p>
								(We encourage customers to reach these carefully
								before they make a purchase, as they will be
								relevant should an issue between a seller and
								customer arise).
							</p>
						</li>
						<li>
							<p>
								Please be aware that in addition to our policy
								here, each country usually has its own unique
								laws relating to product shipping, online order
								exchanges, cancellations, and returns.
							</p>
						</li>
						<li>
							<p>
								We strongly encourage customers and sellers to
								familiarize themselves with the relevant laws of
								their particular country or region, as well as
								with those of the country where customers live.
							</p>
						</li>
						<li>
							<p>
								If a seller can’t complete a transaction, they
								must notify the customer through either their
								shop’s messaging tool, or using a customer’s
								email address – and cancel the transaction. A
								seller may cancel a transaction with a customer
								under the following conditions: 1). A customer
								does not pay, 2). A seller and customer agree to
								cancel a transaction before an item is shipped,
								and before sellers have issued any refunds, 3).
								A customer does not receive the item(s)
								purchased in a shop, even after producing proof
								of item-shipment. The Etho must be notified of
								any changes in orders.
							</p>
						</li>
						<li>
							<p>
								If a shop can’t complete a transaction, and the
								customer already submitted his or her payment,
								the seller must issue a full refund. (We
								encourage customers and sellers alike to keep
								record or any refunds in case a dispute arises.)
								Both sellers and customers may agree that a
								customer can return a purchased item for a
								refund, or for buying “credit” in their shop.
								Keep in mind, NGO’s quite often do not process
								returns and this is noted on their shop page.
								Return options will vary from shop to shop,
								depending on their policies and capabilities.
								The Etho policy is to contact the seller within
								15 days of purchase and return the item to the
								seller within 48 hours. After 30 days there will
								be no returns accepted.
							</p>
						</li>
					</ul>
				</div>
			</Section>
		</div>
	)
}

export default ShippingAndReturns
